import { render, staticRenderFns } from "./FullVideo.vue?vue&type=template&id=0fdf2e89&scoped=true&lang=pug&"
import script from "./FullVideo.vue?vue&type=script&lang=js&"
export * from "./FullVideo.vue?vue&type=script&lang=js&"
import style0 from "./FullVideo.vue?vue&type=style&index=0&id=0fdf2e89&lang=sass&nolang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fdf2e89",
  null
  
)

export default component.exports